const Form007TC = {
    stepName: {
        importantNotes: "重要告示",
        announcements: "填寫電子表格",
        confirmation: "確認",
    },
    label: {
        statement: {
            title: {
                title1: "個人資料收集聲明",
                title2: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
            },
            note: {
                a: "計算及處理發放校本津貼；",
                b: "進行核數工作； ",
                c: "進行研究及統計資料，以便規劃教育服務；",
                d: "執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",
                note1: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
                note2: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
                note3: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
                note4: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
            },
        },
        title: {
            header: "校本課後學習及支援計劃 {{endDateOfCurrentSchoolYear}} 學年",
            title1: "摘要 ",
            title2: "詳情",
            title3: "計劃目的",
            title4: "靈活安排",
            title5: "鼓勵性撥款 ",
            title6: "申請「校本津貼」",
            title7: " 「區本計劃」",
            title8: " 查詢 ",
            title9: "備忘事項︰",
            note: "註",
        },
        note: {
            note1: "本電子表格讓學校申請 {{endDateOfCurrentSchoolYear}} 學年「校本課後學習及支援計劃」(「下稱「課後計劃」) 下的「校本津貼」，以補充學校為支援清貧學生而舉辦的課後活動。",
            note2: "為支援清貧學生參與課後活動，以幫助他們全人發展及個人成長，教育局由 2005/06 學年開始實施「課後計劃」，現時向公營學校 (包括特殊學校)和直接資助計劃學校，以及非政府機構分別提供「校本津貼」及「區本計劃」撥款，為清貧學生分別籌辦校本及區本的課後活動。「課後計劃」的對象學生是那些領取綜合社會保障援助（綜援）及學生資助計劃全額津貼的小一至中六學生。詳情見本局網頁 ( ",
            note2lianjie: "http://www.edb.gov.hk/en/salsp",
            dot: " )。",
            note3: "3. 為了讓更多不在綜援／學生資助計劃全額津貼之列但亦屬清貧而需學校多加照顧的學生也能受惠，教育局為參與學校提供酌情名額；並由 2014/15 學年開始，把有關名額由 10%增加至 25%，讓更多學生受惠。此外，學校可運用「校本津貼」購買物資／器材 (例如運動用品／具教育意義的益智玩具／棋類／書籍／小食／飲料等)，以及資助個別學生參與課後活動的交通費。惟上述開支須切合活動需要，並只適用於參與課後活動的清貧學生。為避免上述開支與獲提供的「校本津貼」不成比例，上述開支的總額不應超逾學校獲提供的「校本津貼」總額的 5%。 ",
            note4: "4. 本局會審視參與學校已提交的最近一年周年帳目",
            note4a: "，視乎學校運用「校本津貼」的情況，為參與學校提供鼓勵性撥款。具體來說，所有在「校本津貼」使用率",
            note4b: "達80%或以上的參與學校，每名合資格學生的每年「校本津貼」額會由原來的400元上調至600元，而有關學校亦會獲得以600元計算因酌情名額而提供的額外25%的「校本津貼」。至於其他參與學校，每名合資格學生的每年「校本津貼」額則以400元計算。",
            note4c: "",
            note5: "學校須於指定截止日期前提交電子表格予延伸支援計劃組辦理。",
            // note5a: "2020年6月22日",
            // note5b: "或之前交回本局延伸支援計劃組辦理。我們一貫會在 2020 年 7 月下旬撥款予參加學校，同時知會學校計算撥款的詳情。",
            note6: "6. 若學校與非政府機構協作推行 2020/21 學年「區本計劃」 (如適用)，亦請學校協助監察有關機構執行計劃的進度及表現，並與其保持緊密溝通，確保所提供的服務切合清貧學生的不同需要。由 2017/18 學年起，本局已調整「區本計劃」有關財務的安排，當中包括發放予非政府機構三期撥款的比例及機構遞交周年帳目的日期等，以利「區本計劃」能更有效地推行。詳情請參閱載於本局網頁的「區本計劃指引」( ",
            note6lianjie: "http://www.edb.gov.hk/salsp ",
            note7: " → 區本計劃 ).",
            note8: "如有查詢，請與延伸支援計劃組聯絡 (電話： 2892 6653)。",
            note9: "教育局常任秘書長",
            note10: "陳慕顏代行",
            note11: " ",
            note12: "二零二零年五月二十七日 ",
            note13: "1. 資助、按位津貼學校及直接資助計劃學校的周年帳目以學年為基礎；現時學校呈交最近一年的周年帳目為 2018/19 學年；官立學校則以財政年度為基礎，即 2019-20 財政年度的帳目。",
            note14: "2. 使用率按有關年度「校本津貼」實際總開支及獲提供「校本津貼」的撥款總額計算。",
            note15: "_______________________________",
            note16: "1.「校本課後學習及支援計劃」的撥款屬補充性質。為照顧清貧學生的不同需要，教育局鼓勵學校靈活調配資源，及／或參加現時政府／慈善機構設有的多個資助計劃。",
            note17: "2. 學校應讓相關持份者包括家長了解學校如何在課後活動方面支援清貧學生，進一步提高透明度。此外，學校須於學校周年計劃內具體列明校本計劃的安排，並須於 2020 年 10 月底前把學校周年計劃上載學校網頁。學校須每年檢討校本計劃，並在學校報告反映檢討結果。學校須於 2020 年 11 月底前把報告上載學校網頁，否則，2020/21 年度發放的「校本津貼」會被撤回。",
            note18: "3. 學校可保留「校本津貼」的剩餘款項，但以不超逾當年度「校本津貼」的撥款總額為限，超出的款項須退還教育局。至於官立學校方面，有關安排則以財政年度為基礎。",
            note19: "就本學年的「校本課後學習及支援計劃 - 校本津貼」申請，本校已知悉有關計劃的安排。",
        },
        termsConditions: "本人已閱讀、明白及同意上述條款及細則。",
        iamSignCheck: "本人理解此電子表格必須由校監使用「智方便+」簽署。",
        header: "(請在適當方格內加上“√”號) ：      ",
        reason: "原因：",
        headerOption: {
            header1:
                "本校遵照「校本課後學習及支援計劃」的條件，申領「校本津貼」，為合資格學生籌辦校本課後學習活動。  ",
            header2: "本校無意申領「校本津貼」。 ",
        },
        namOofSupervisor: "校監姓名",
        nameOfSchool: "學校名稱",
        schoolCode: "學校編號",
        schoolLevel: "學校級別",
        financeType: "財政類別",
        schoolTelNo: "學校電話號碼",
        contactPerson: "聯絡人姓名",
        errorMsg: {
            E0001: "如果你選擇了第二個選項，請寫明原因",
            E0002: "請輸入一個有效的原因",
            notTheSame: "選項1和選項2不能同時選擇",
            schoolCodeMin: "請輸入6位數的學校代碼",
        },
        memorandum: {
            title: "備忘事項：",
            noteOptions: {
                text0: "「校本課後學習及支援計劃」屬補充性質，教育局鼓勵學校靈活調配「校本津貼」及其他各項相關津貼，加強協同效應，為清貧學生舉辦多元化的課後學習活動。",

                text1: "學校應讓相關持份者包括家長了解學校如何在課後學習活動方面支援清貧學生，進一步提高透明度。此外，學校須將其運用「校本津貼」支援清貧學生的校本計劃及其他配套措施（如有）具體列明在活動計劃表內，並須於{{schoolyearBefore}}年10月底前把活動計劃表連同學校周年計劃上載至學校網頁。學校須每年檢討運用「校本津貼」的情況，並在活動報告表反映檢討結果，有關活動報告表須連同學校報告於{{schoolyearAfter}}年11月底前上載至學校網頁。若學校未能符合上述要求，{{schoolyear}}年度發放的「校本津貼」或會被撤回。",

                text2: "學校須每年填寫「校本津貼」問卷，並交回教育局，讓教育局了解學校運用「校本津貼」的情況。",

                text3: "資助、按位津貼及直接資助計劃學校可保留「校本津貼」的剩餘款項，但以不超逾相關學年「校本津貼」的撥款總額為限，超出的款項須退還教育局。至於官立學校方面，學校可按校情預先申請保留每一年度的「校本津貼」，剩餘的「校本津貼」須於該財政年度完結時退還教育局。",
            },
        },
    },
    dialog: {
        message:
            "提交表格後，系統會發出電郵通知指定審批人(一般為校監)進行審批。申請人不能再修改已提交的表格。",
    },
};
export default Form007TC;
